import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filters", "icon"]
  
  connect() {
    // Initialize with filters hidden
    this.filtersTarget.classList.add("hidden")
    this.updateIcon()
  }
  
  toggle() {
    this.filtersTarget.classList.toggle("hidden")
    this.updateIcon()
  }
  
  updateIcon() {
    const isHidden = this.filtersTarget.classList.contains("hidden")
    this.iconTarget.textContent = isHidden ? "▼" : "▲"
  }
}